import axios from 'axios';
import authHeader from './auth-header';
import http from "../http-common";

const API_URL = 'https://db.irli.org:8080/api/';

class AxiosService {

  getAll(path) {
    return axios.get(API_URL + path, { headers: authHeader() });
  }

  get(path, id) {
    return axios.get(API_URL + path + `/${id}`, { headers: authHeader() });
  }

  create(path, data) {
    return axios.post(API_URL + path, data, { headers: authHeader() });
  }

  update(path, id, data) {
    return axios.put(API_URL + path + `/${id}`, data, { headers: authHeader() });
  }

  delete(path, id) {
    return axios.delete(API_URL + path + `/${id}`, { headers: authHeader() });
  }

  deleteAll(path) {
    return axios.delete(API_URL + path, { headers: authHeader() });
  }

}

export default new AxiosService();